import clsx from 'clsx';
import React, { ReactElement, useEffect } from 'react';
import { useParams } from 'react-router';

import { EmailFileEntry, FileEntry } from '@/src/components/project/Inbox2/types';

import useEmailFileEntryViewerStore from './useEmailFileEntryViewerStore';

import DefaultFileEntryViewer from '../../../FileEntryViewer/FileEntryViewer';
import { FileEntryViewerInfoPanelProvider } from '../../../FileEntryViewer/store/fileEntryViewer.infoPanel.store';
import { FileEntryViewerSidebarActionsProvider } from '../../../FileEntryViewer/store/fileEntryViewer.sidebarActions.store';
import { FileEntryViewerProvider } from '../../../FileEntryViewer/store/fileEntryViewer.store';
import { FileEntryViewerTreatmentProvider } from '../../../FileEntryViewer/store/fileEntryViewer.treatment.store';
import { useEmailThreadEntryViewer } from '../../store/emailThreadEntryViewer.store';

type MainEmailFileEntryViewer = {
  emailId: number;
  inboxEntryId: number;
  allFiles: EmailFileEntry[];
  isLoading: boolean;
  mappedFileEntry: FileEntry;
  nextIndex: number;
  Header: ReactElement;
  onSetEmailFileEntry: (emailFileEntry: any) => void;
  setNextIndex: (index: number) => void;
};

const MainEmailFileEntryViewer = ({
  emailId,
  inboxEntryId,
  allFiles,
  mappedFileEntry,
  nextIndex,
  setNextIndex,
  onSetEmailFileEntry,
  Header,
}: MainEmailFileEntryViewer) => {
  const { projectId } = useParams<{ projectId: string }>();
  const { isFullScreen } = useEmailThreadEntryViewer();

  useEffect(() => {
    if (!allFiles[nextIndex]) {
      return;
    }

    onSetEmailFileEntry(allFiles[nextIndex]);
    setNextIndex(null);
  }, [nextIndex, allFiles, onSetEmailFileEntry, setNextIndex]);

  const { sidebarActions, treatmentEvents, infoPanelQueries } = useEmailFileEntryViewerStore({
    projectId,
    emailId,
    inboxEntryId,
    fileId: mappedFileEntry.id,
    documentFileId: mappedFileEntry.file.id,
  });

  return (
    <FileEntryViewerTreatmentProvider treatmentEvents={treatmentEvents}>
      <FileEntryViewerInfoPanelProvider infoPanelQueries={infoPanelQueries}>
        <FileEntryViewerSidebarActionsProvider sidebarActions={sidebarActions}>
          <FileEntryViewerProvider>
            {/* {isLoading && <SectionLoader loaderType={LOADER_TYPE.screen} />} */}
            <DefaultFileEntryViewer
              key={`dfe_${mappedFileEntry.id}`}
              fileEntry={mappedFileEntry}
              header={Header}
              mainContainerClass={clsx(
                '!tw-p-0',
                'tw-bg-white',
                // We set this at default but fileviewer fullScreen state can stil influence/override this
                'tw-sticky tw-top-0 tw-left-0 tw-z-[10]',
                isFullScreen ? '!tw-w-full tw-h-full' : 'tw-max-h-full'
              )}
              entryCardClass={clsx(
                isFullScreen ? 'tw-h-full' : 'tw-min-h-[calc(100vh-245px)] tw-mr-[5px]'
              )}
              isContainerFullScreen={isFullScreen}
              sidebarSettings={{
                isDeleteEnabled: false,
                canMaximizeMinimize: true,
              }}
              settings={{
                isTransactionsEnabled: true,
                isViewInQuickbooksEnabled: true,
              }}
            />
          </FileEntryViewerProvider>
        </FileEntryViewerSidebarActionsProvider>
      </FileEntryViewerInfoPanelProvider>
    </FileEntryViewerTreatmentProvider>
  );
};

export default MainEmailFileEntryViewer;
